/** 
 * [Ref] - Denotes Pseudo Code Reference
 * Author: Chandrasekar
 * Created Date: 07/30/2020
 * 
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
 * Ref: MN_PC_56/MN_PC_57
*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
window.jQuery = $;
require("jquery-toast-plugin/dist/jquery.toast.min.js");
require("jquery-toast-plugin/dist/jquery.toast.min.css");
const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
/**
* MN_PC_58
* This method retrieves the user menu data from API
*/
const getMenuItems = async (menuBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_BindUserMenu,
            JSON.stringify(menuBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.Menu_BindUserMenu, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const WorkOrderCheck = async (WorkOrderBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(WorkOrderBO),
            (data) => {
                if (data.success) {

                    if (data.response != "" && data.response != "[]" && data.response != [] && data.response) {
                        let contentData = { type: "workordercheckmenu", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else {
                        let contentData = { type: "workorderfailmenu", response: "failed" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

/**
* MN_PC_59/MN_PC_60/MN_PC_61/MN_PC_62/MN_PC_63
* /MN_PC_64/MN_PC_65/MN_PC_66
* This method retrieves the master data from API
*/
/*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
const getCartData = async (masterBO) => {
    try {

        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCartCount,
            JSON.stringify(masterBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "CartCount", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const getMasterData = async (masterBO) => {
    try {

        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetMasterData,
            JSON.stringify(masterBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.Menu_GetMasterData, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
* MN_PC_67
* This method retrieves the environment and logo data from API
*/
const getEnvironmentDetails = async (environmentBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetEnvironmentDetails,
            JSON.stringify(environmentBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.Menu_GetEnvironmentDetails, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
* MN_PC_69
* This method adds the favorite item to cart
*/
const addFavItemsTocart = async (favCartBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.Menu_AddFavItemtoCart,
            JSON.stringify(favCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "MENU_AddFavItemsToCart", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
* MN_PC_69
* This method adds the favorite order line item to cart
*/
const addFavOrderItemsTocart = async (favOrderCartBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavOrder,
            SDIConstants.methodNames.FavOrder_ReorderItems,
            JSON.stringify(favOrderCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "MENU_AddFavOrderItemsToCart", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
* This method gets the search suggestions from API
*/
const getSearchSuggestions = async (searchBO) => {
    try {
        let responseData = "";
        await SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_SearchSuggestions,
            JSON.stringify(searchBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        responseData = data.response;
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
        return responseData;

    } catch (ex) {
        console.log(ex)
        return "";
    }
};
/*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
const refreshCartCount = () => {
    try {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        };
        console.log("masterBO2", masterBO);
        getCartData(masterBO);
    } catch (ex) {
        console.log(ex)
    }
};
const refreshMasterData = () => {
    try {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,//isFirstTimeLoaded 
            User_Type: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
            IsWeb: true
        };
        console.log("masterBO2", masterBO);
        getMasterData(masterBO);

    } catch (ex) {
        console.log(ex)
    }
};
const toastMessage = (type) => {
    try {
        $.toast({
            heading: 'Favorite Page',
            text: type == 1 ? 'Added to favorite pages' : 'Removed from favorite pages',
            position: {
                top: 175,
                bottom: 90,
                left: 600
            },
            stack: false,
            loader: false
        });
        refreshMasterData();

    } catch (ex) {
        console.log(ex)
    }
};
/*'[10/04/22,WW-521_10-Toast message for Feedback response], Priyanka D */
const feedbackresponse = () => {
    try {
        $.toast({
            text: 'Thankyou for your Response',
            position: {
                top: 175,
                bottom: 90,
                left: 600
            },
            stack: false,
            loader: false
        });
        refreshMasterData();

    } catch (ex) {
        console.log(ex)
    }
};
const CopyMessage = () => {
    try {
        $.toast({
            text: 'Copied To ClipBoard',
            position: {
                top: 175,
                bottom: 90,
                left: 600
            },
            stack: false,
            loader: false
        });
        refreshMasterData();

    } catch (ex) {
        console.log(ex)
    }
};

const HALMessage = () => {
    try {
        $.toast({
            text: 'HAL Locations will be displayed based on the selected ship to store',
            position: {
                top: 175,
                bottom: 90,
                left: 600
            },
            stack: false,
            loader: false
        });
        refreshMasterData();

    } catch (ex) {
        console.log(ex)
    }
};
const refreshMasterDataWithFullPrivileges = () => {
    try {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: true,
            isOrderApproval: true,
            isFavItem: true,
            isFavOrder: true,
            isFirstTime: true,
            IsWeb: true//isFirstTimeLoaded
        };
        console.log("masterBO2", masterBO);
        getMasterData(masterBO);

    } catch (ex) {
        console.log(ex)
    }
};
/**
* MN_PC_58
* This refresh method retrieves the user menu data from API
*/
const refreshMenuItems = async (fromLogin, props) => {
    try {
        let menuBO = {
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_MenuUpdated: "False",
            Session_SDIMenu: "",
            Session_BARCODE: CookieService.getLocalStorageValues("Session_BARCODE") ? CookieService.getLocalStorageValues("Session_BARCODE") : "",
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
            Session_DEFAULTPAGE: CookieService.getLocalStorageValues("Session_DEFAULTPAGE"),
            Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
            Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERNAME: CookieService.getLocalStorageValues("Session_AGENTUSERNAME") ? CookieService.getLocalStorageValues("Session_AGENTUSERNAME") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME")
        }

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_BindUserMenu,
            JSON.stringify(menuBO),
            (data) => {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.Menu_BindUserMenu, response: data.response };
                        Dispatcher.dispatch(contentData);
                        console.log("data.response", data.response);
                        let response = JSON.parse(data.response);
                        localStorage.setItem("SDIMenu", JSON.stringify(response.UserMenu));
                        //WW-1229 Update Home tiles to local storage -Nandhini L
                        localStorage.setItem("SDIHomeMenu", JSON.stringify(response.r_result_usertiles));
                        localStorage.setItem("SDICategories", JSON.stringify(response.Categories));
                        if (fromLogin) {
                            props.history.push({
                                pathname: '/HomePage',
                            });
                        }
                        refreshMasterDataWithFullPrivileges();
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};


/*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
export { getMenuItems, WorkOrderCheck, getMasterData, getEnvironmentDetails, addFavItemsTocart, addFavOrderItemsTocart, getSearchSuggestions, HALMessage, tokenExpired, toastMessage, refreshMasterData, refreshMenuItems, refreshCartCount, CopyMessage, feedbackresponse }